import { HorizontalContainer } from '@american-autonomy/ag-ui';

import PrimaryButton from 'components/buttons/PrimaryButton';

import useTranslation from 'pages/ApplicationDetailsPage/hooks/useTranslation';

import { DISCARD_TEST_ID, SAVE_TEST_ID, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FlightPlannerPanelHeader: FunctionComponent<Props> = ({
    className = '',
    isSaving,
    onDiscard,
    onSave,
    testId = TEST_ID
}) => {
    const { DISCARD, SAVE } = useTranslation();

    return (
        <HorizontalContainer
            className={`${className} ${styles.flightPlannerPanelHeader}`}
            testId={testId}>
            <PrimaryButton
                className={styles.discardButton}
                isDisabled={isSaving}
                onClick={onDiscard}
                testId={DISCARD_TEST_ID}
                text={DISCARD}
            />

            <PrimaryButton
                isDisabled={isSaving}
                onClick={onSave}
                testId={SAVE_TEST_ID}
                text={SAVE}
            />
        </HorizontalContainer>
    );
};

export default FlightPlannerPanelHeader;
